import axios from './biAxios';
import authHeader from "./authentification-header";

const API_URL = "/api/dropdown/";

const getPlant = () => axios
    .get(`${API_URL}plant`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getProduct = (plant) => axios
    .get(`${API_URL}material?plant=${plant ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getTransport = (plant, ticketId, planId) => axios
    .get(`${API_URL}transport?plant=${plant ?? ''}&ticketId=${ticketId ?? ''}&planId=${planId ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getTicketStatus = (ticketId, planId) => axios
    .get(`${API_URL}ticketstatus?ticketId=${ticketId ?? ''}&planId=${planId ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getPlanUnit = () => axios
    .get(`${API_URL}planunit`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getTicketType = () => axios
    .get(`${API_URL}tickettype`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getTicketMode = () => axios
    .get(`${API_URL}ticketmode`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getDriver = (plant, ticketId, planId) => axios
    .get(`${API_URL}driver?plant=${plant ?? ''}&ticketId=${ticketId ?? ''}&planId=${planId ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getTruck = (plant, ticketId, planId) => axios
    .get(`${API_URL}truck?plant=${plant ?? ''}&ticketId=${ticketId ?? ''}&planId=${planId ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getArea = (plant) => axios
    .get(`${API_URL}area?plant=${plant ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getPoint = (plant, area) => axios
    .get(`${API_URL}point?plant=${plant ?? ''}&area=${area ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getArm = (plant, area, point) => axios
    .get(`${API_URL}arm?plant=${plant ?? ''}&area=${area ?? ''}&point=${point ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getPlan = (date, ticketId, planId) => axios
    .get(`${API_URL}plan?date=${date}&ticketId=${ticketId ?? ''}&planId=${planId ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));

const allActions = {
    getPlant,
    getProduct,
    getTransport,
    getTicketStatus,
    getPlanUnit,
    getTicketType,
    getTicketMode,
    getDriver,
    getTruck,
    getArea,
    getPoint,
    getArm,
    getPlan,
};

export default allActions;